import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import EventCard from '../../components/public/EventCard';
import api from '../../utils/api';
import '../../components/public/Public.css';

const ICON_STRIP = [
  { ic: '🎓', title: 'Learn', sub: 'Practical AI Skills' },
  { ic: '🤝', title: 'Connect', sub: 'With a Global Community' },
  { ic: '🛠️', title: 'Build', sub: 'Real World Projects' },
  { ic: '🏢', title: 'For Organisations', sub: 'Training & Consultancy' },
  { ic: '📈', title: 'Grow', sub: 'Your Future Opportunities' },
];

const COURSES = [
  { tag: 'Beginner', cls: 'tag-beginner', ic: '🧠', title: 'AI Foundations', desc: 'Understand AI and its real-world applications.', hours: '6 hours', rating: 4.8, reviews: '2.1K' },
  { tag: 'Popular', cls: 'tag-popular', ic: '💡', title: 'AI for Business', desc: 'Use AI to grow your business and improve productivity.', hours: '8 hours', rating: 4.7, reviews: '1.8K' },
  { tag: 'New', cls: 'tag-new', ic: '⚙️', title: 'AI Tools and Automation', desc: 'Master the latest AI tools and automate your workflows.', hours: '5 hours', rating: 4.9, reviews: '1.2K' },
  { tag: 'Intermediate', cls: 'tag-intermediate', ic: '✍️', title: 'Prompt Engineering', desc: 'Learn to communicate effectively with AI tools.', hours: '4 hours', rating: 4.8, reviews: '980' },
  { tag: 'Business', cls: 'tag-business', ic: '🏢', title: 'AI for Organisations', desc: 'Implement AI in your organisation with confidence.', hours: '6 hours', rating: 4.7, reviews: '640' },
];

const COMMUNITY_STATS = [
  { ic: '👥', n: '50K+', l: 'Members' },
  { ic: '🌍', n: '100+', l: 'Countries' },
  { ic: '🎓', n: '200+', l: 'Courses' },
  { ic: '🎥', n: 'Live', l: 'Webinars' },
];

export default function Home() {
  const [events, setEvents]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState('all');
  const [email, setEmail]     = useState('');
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    let active = true;
    api.get('/public/events')
      .then(r => { if (active) setEvents(Array.isArray(r.data) ? r.data : []); })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const filtered = events.filter(e =>
    filter === 'free' ? e.is_free : filter === 'paid' ? !e.is_free : true
  );

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
  };

  return (
    <div className="pub-page">
      <Navbar />

      {/* ── Hero ─────────────────────────────────────────── */}
      <section className="pub-hero" id="home">
        <div className="pub-container pub-hero-grid">
          <div className="pub-hero-copy">
            <h1>Learn AI Today<br /><span>Build a Better Tomorrow</span></h1>
            <p>Join a global community of learners, professionals and organisations using Artificial Intelligence to create real opportunities, solve real problems and build a brighter future.</p>
            <div className="pub-hero-actions">
              <a href="#events" className="pub-btn pub-btn-primary">Join AIWC Free →</a>
              <a href="#courses" className="pub-btn pub-btn-outline">Explore Courses ▶</a>
            </div>
            <div className="pub-hero-metrics">
              <div className="pub-hero-metric"><span className="ic">👥</span><div><div className="n">50K+</div><div className="l">Learners Worldwide</div></div></div>
              <div className="pub-hero-metric"><span className="ic">📚</span><div><div className="n">200+</div><div className="l">Courses</div></div></div>
              <div className="pub-hero-metric"><span className="ic">🎥</span><div><div className="n">Live</div><div className="l">Webinars</div></div></div>
              <div className="pub-hero-metric"><span className="ic">🌍</span><div><div className="n">Global</div><div className="l">Community</div></div></div>
            </div>
          </div>

          <div className="pub-hero-visual">
            <div className="pub-hero-globe">
              <svg viewBox="0 0 300 300" className="pub-globe-svg">
                <circle cx="150" cy="150" r="110" fill="none" stroke="rgba(255,255,255,.22)" strokeWidth="1.5" />
                <ellipse cx="150" cy="150" rx="110" ry="40" fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="1" />
                <ellipse cx="150" cy="150" rx="110" ry="75" fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="1" />
                <line x1="40" y1="150" x2="260" y2="150" stroke="rgba(255,255,255,.18)" strokeWidth="1" />
                <line x1="150" y1="40" x2="150" y2="260" stroke="rgba(255,255,255,.18)" strokeWidth="1" />
                <circle cx="90" cy="100" r="4" fill="#8AF5D4" />
                <circle cx="205" cy="120" r="3" fill="#8AB8FF" />
                <circle cx="120" cy="210" r="3.5" fill="#FFCB8A" />
                <circle cx="190" cy="195" r="3" fill="#8AF5D4" />
                <line x1="90" y1="100" x2="205" y2="120" stroke="rgba(255,255,255,.3)" strokeWidth="1" />
                <line x1="120" y1="210" x2="190" y2="195" stroke="rgba(255,255,255,.3)" strokeWidth="1" />
                <line x1="90" y1="100" x2="120" y2="210" stroke="rgba(255,255,255,.2)" strokeWidth="1" />
              </svg>
            </div>

            <div className="pub-hero-card pub-hero-card-opp">
              <h4>AI Creates Opportunity</h4>
              <ul>
                <li><span>🎓</span>Learn New Skills</li>
                <li><span>💼</span>Build Your Career</li>
                <li><span>📈</span>Grow Your Business</li>
                <li><span>🌐</span>Connect Globally</li>
              </ul>
            </div>

            <div className="pub-hero-card pub-hero-card-quote">
              <p>"AIWC has given me the skills and confidence to start my own AI consultancy business."</p>
              <div className="who">
                <span className="avatar">A</span>
                <div><div className="name">Ama Serwaa</div><div className="loc">Ghana</div></div>
              </div>
              <div className="dots"><span className="active" /><span /><span /><span /></div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Icon strip ───────────────────────────────────── */}
      <section className="pub-iconstrip">
        <div className="pub-container pub-iconstrip-grid">
          {ICON_STRIP.map(item => (
            <div className="pub-iconstrip-item" key={item.title}>
              <span className="ic">{item.ic}</span>
              <div>
                <div className="t">{item.title}</div>
                <div className="s">{item.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Featured courses ─────────────────────────────── */}
      <section className="pub-section" id="courses">
        <div className="pub-container">
          <div className="pub-section-head">
            <div>
              <h2>Featured Courses</h2>
              <p>Practical, up-to-date and designed for real-world impact.</p>
            </div>
            <a href="#courses" className="pub-link-arrow">View All Courses →</a>
          </div>

          <div className="pub-courses-grid">
            {COURSES.map(c => (
              <div className="course-card" key={c.title}>
                <div className="course-card-media">
                  <span className={`course-tag ${c.cls}`}>{c.tag}</span>
                  <span className="course-ic">{c.ic}</span>
                </div>
                <div className="course-card-body">
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                  <div className="course-card-meta">
                    <span>🕒 {c.hours}</span>
                    <span>⭐ {c.rating} ({c.reviews})</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Upcoming events (real data) ──────────────────── */}
      <section className="pub-section pub-section-alt" id="events">
        <div className="pub-container">
          <div className="pub-section-head">
            <div>
              <h2>Upcoming Events</h2>
              <p>Live webinars, workshops, and conferences — reserve your spot in under a minute.</p>
            </div>
            <div className="pub-filters">
              {[['all', 'All'], ['free', 'Free'], ['paid', 'Paid']].map(([k, l]) => (
                <button key={k} className={`pub-filter ${filter === k ? 'active' : ''}`} onClick={() => setFilter(k)}>{l}</button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="pub-loading"><div className="pub-spinner" /></div>
          ) : filtered.length === 0 ? (
            <div className="pub-empty">
              <div className="pub-empty-ic">🗓️</div>
              <h3>No events yet</h3>
              <p>{filter === 'all' ? 'Check back soon — new events are added regularly.' : `No ${filter} events right now.`}</p>
            </div>
          ) : (
            <div className="pub-events-grid">
              {filtered.map(ev => <EventCard key={ev.id} event={ev} />)}
            </div>
          )}
        </div>
      </section>

      {/* ── How it works ──────────────────────────────────── */}
      <section className="pub-features" id="features">
        <div className="pub-container">
          <div className="pub-features-grid">
            <div className="pub-feature">
              <div className="pub-feature-ic">⚡</div>
              <h3>Register in seconds</h3>
              <p>Returning guests are recognised instantly — no forms to fill again. New guests verify once and they're in.</p>
            </div>
            <div className="pub-feature">
              <div className="pub-feature-ic">🔒</div>
              <h3>Pay your way</h3>
              <p>Mobile Money, bank transfer, or card. Secure checkout with instant confirmation when it clears.</p>
            </div>
            <div className="pub-feature">
              <div className="pub-feature-ic">📩</div>
              <h3>Instant confirmation</h3>
              <p>Get an email and SMS the moment your spot is secured, with all the event details you need.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Community band ──────────────────────────────── */}
      <section className="pub-community" id="community">
        <div className="pub-container pub-community-inner">
          <div className="pub-community-copy">
            <h2>A Global Community Making an Impact</h2>
            <p>Join learners, educators and organisations from over 100 countries.</p>
            <div className="pub-community-stats">
              {COMMUNITY_STATS.map(s => (
                <div className="pub-community-stat" key={s.l}>
                  <span className="ic">{s.ic}</span>
                  <div className="n">{s.n}</div>
                  <div className="l">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="pub-community-quote">
            <p>"AIWC is more than a learning platform. It's a movement for a better, more inclusive future powered by AI."</p>
            <div className="who">— AIWC Community</div>
          </div>
        </div>
      </section>

      {/* ── Email capture CTA ───────────────────────────── */}
      <section className="pub-cta-band">
        <div className="pub-container pub-cta-inner">
          <div className="pub-cta-copy">
            <h2>Be Part of the AI Revolution</h2>
            <p>Create your free account today and start your AI journey.</p>
          </div>
          {subscribed ? (
            <div className="pub-cta-success">✓ Thanks! Check your inbox to confirm.</div>
          ) : (
            <form className="pub-cta-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="pub-btn pub-btn-light">Get Started →</button>
            </form>
          )}
          <p className="pub-cta-note">No credit card required</p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
